import { Splide } from '@hh/global.js'

class SrOnlyArrowSlider extends HTMLElement {
  connectedCallback() {
    this.initSlider()
    this.adjustButtons()
  }

  initSlider() {
    this.slider = new Splide(this, {
      drag: 'free',
      arrows: true,
      pagination: false
    }).mount()
  }

  adjustButtons() {
    const prevButton = this.querySelector('[data-prev-button]')
    const nextButton = this.querySelector('[data-next-button]')
    prevButton?.setAttribute(
      'aria-label',
      `${this.getAttribute("slider-title") ?? ''}, Previous Slide`
    );
    nextButton?.setAttribute(
      "aria-label",
      `${this.getAttribute("slider-title") ?? ''}, Next Slide`
    );
    this.prepend(prevButton ?? '')
    this.append(nextButton ?? '')
  }
}

customElements.define('free-slider', SrOnlyArrowSlider)
